module.exports = __webpack_public_path__ + "media/images/airplane-6f392d527e23dcf3ad64382852dea4c8.jpg";